module.exports = __webpack_public_path__ + "img/nav-soundcheck-off.f8606e4d.png";